<form [formGroup]="formLocation">
  <div class="card m-3">
    <h5 class="card-header">Kaizen Location <span class="legend-label">{{requiredLegend}}</span></h5>
    <div class="card-body">
      <div class="form-group row">
        <label for="NAMC" class="col-sm-3 p-1 col-form-label-textbox-center">NAMC Impacted *</label>
        <div class="col-sm-3 p-1">
          <select class="form-select" formControlName="companyID" required (change)="changeCompany($event)" id="NAMC">
            <option value="">Select NAMC</option>
            @for (company of companies; track company) {
              <option [value]="company.companyID">
                {{company.companyName}}
              </option>
            }
          </select>
          @if (formLocation.get('companyID')?.errors?.['required'] && formLocation.get('companyID')?.touched) {
            <small class="invalid" >NAMC
            is required field</small>
          }
        </div>
        <label for="supportingNAMC" class="col-sm-3 p-1 col-form-label-textbox-center">Supporting NAMC:</label>
        <div class="col-sm-3">
          <select class="form-select" formControlName="supportingCompanyId" (change)="changeSupportingCompany($event)" id="supportingNAMC">
            <option value="">Select supporting NAMC</option>
            @for (company of  allCompanies; track company) {
              <option [value]="company.companyID">{{company.companyName}}</option>
            }
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="kaizenImpactingModelId" class="col-sm-3 p-1 col-form-label-textbox-center">Calculate savings impact *</label>
        <div class="col-sm-3 p-1">
          <select class="form-select" formControlName="kaizenImpactingModelId" id="kaizenImpactingModelId" required
            (change)="changekaizenImpactingModel($event)">
            <option value="">Select Savings Impact</option>
            @for (impactingModel of  kaizenImpactingModel; track impactingModel) {
              <option
                [value]="impactingModel.kaizenImpactingModelID">
              {{impactingModel.name}}</option>
            }
          </select>
          @if (formLocation.get('kaizenImpactingModelId')?.errors?.['required'] && formLocation.get('kaizenImpactingModelId')?.touched) {
            <small class="invalid">Savings Impact is a required field</small>
          }
        </div>
        <label for="supportingLine" class="col-sm-3 p-1 col-form-label-textbox-center">Supporting Line:</label>
        <div class="col-sm-3">
          <select class="form-select" formControlName="supportingLineId" (change)="changeSupportingLine($event)"id="supportingLine">
            <option value="">Select supporting Line</option>
            @for (line of  filteredSupportingLines; track line) {
              <option [value]="line.lineID">{{line.lineName}}</option>
            }
          </select>
        </div>
      </div>
      <div class="form-group row">
        <label for="shopId" class="col-sm-3 p-1 col-form-label-textbox-center">Shop Impacted *</label>
        <div class="col-sm-3 p-1">
          <div class="autocomp">
            <mat-form-field   appearance="fill"  class="col-sm-12" style="margin-left: 0px;padding-left: 0px;">
              <input   type="text" placeholder="Pick Shop" aria-label="Number" matInput id="shopId"
                [formControl]="shopControl" [matAutocomplete]="auto2" required
                [class.invalid]="shopControl.invalid && shopControl.touched">
                <mat-autocomplete #auto2="matAutocomplete">
                  @for (option of  filteredShops | async; track option) {
                    <mat-option [value]="option.name">
                      {{option.name}}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            </div>
          </div>
          <label for="supportingShopId" class="col-sm-3 p-1 col-form-label-textbox-center">Supporting Shop:</label>
          <div class="col-sm-3">
            <select class="form-select" formControlName="supportingShopId" (change)="changeSupportingShop($event)" id="supportingShopId">
              <option value="">Select supporting Shop</option>
              @for (shop of  filteredSupportingShops; track shop) {
                <option [value]="shop.shopID">{{shop.name}}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="line" class="col-sm-3 p-1 col-form-label-textbox-center">Line Impacted *</label>
          <div class="col-sm-3 p-1">
            <select class="form-select" formControlName="lineId" required (change)="changeLine($event)" id="line">
              <option value="">Select Line</option>
              @for (line of  filteredLines; track line) {
                <option [value]="line.lineID">{{line.lineName}}</option>
              }
            </select>
            @if (formLocation.get('lineId')?.errors?.['required'] && formLocation.get('lineId')?.touched) {
              <small class="invalid" >Line
              is required field</small>
            }
          </div>
          <label for="supportingCostCenterID" class="col-sm-3 p-1 col-form-label-textbox-center">Supporting Cost
          Center:</label>
          <div class="col-sm-3">
            <select class="form-select" formControlName="supportingCostCenterID" id="supportingCostCenterID" (change)="changeSupportingCostCenter($event)">
              <option value="">Select cost center</option>
              @for (scostCenter of  filteredSupportingcostCenters; track scostCenter) {
                <option [value]="scostCenter.costCenterID">
                {{scostCenter.costCenterName}}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="costCenter" class="col-sm-3 p-1 col-form-label-textbox-center">Cost Center:</label>
          <div class="col-sm-3 p-1">
            <select class="form-select" formControlName="costCenterID" (change)="changeCostCenter($event)" id="costCenter">
              <option value="">Select cost center</option>
              @for (costCenter of  filteredCostCenters; track costCenter.costCenterID) {
                <option [value]="costCenter.costCenterID">
                {{costCenter.costCenterName}}</option>
              }
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="model" class="col-sm-3 p-1 col-form-label-textbox-center">Model/Area Impacted:</label>
          <div class="col-sm-3 p-1">
            <select class="form-select" id="model" formControlName="modelId" (change)="changeModelImpacted($event)">
              <option value="">Select the model</option>
              @for (vehicleModel of  filteredVehicleModels; track vehicleModel) {
                <option [value]="vehicleModel.vehicleModelID">
                {{vehicleModel.modelName}}</option>
              }
            </select>
            @if (formLocation.get('modelId')?.errors?.['required'] && formLocation.get('kaizenImpactingModelId')?.value=='4') {
              <small class="invalid" >Model
              Impacted is required field</small>
            }

          </div>

        </div>
      </div>
    </div>
  </form>